<template>
  <div id="app">
    <my-header></my-header>
    <about-lite style="overflow: hidden; width: 80%"></about-lite>
    <my-footer id="footer"></my-footer>
  </div>
</template>

<script>

// import AboutLite from './pages/about-lite.vue'
const AboutLite = () => import('./pages/about-lite.vue')
const MyHeader = () => import('./components/header.vue')
const MyFooter = () => import('./components/footer.vue')

export default {
  name: 'App',
  components: {
    AboutLite,
    MyHeader,
    MyFooter
  }
}
</script>

<style>
html {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

body {
  display: flex;
  flex-direction: column;
  align-items: center;
}

#app {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 595px;
}

#footer {
  margin-top: 25px;
}

p {
  text-indent: 1em;
  text-align: justify;
}

</style>
